function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_867",
  "data-name": "Group 867",
  transform: "translate(-46 -398.829)"
}, React.createElement("g", {
  id: "project-management",
  transform: "translate(46 398.763)"
}, React.createElement("g", {
  id: "Group_462",
  "data-name": "Group 462",
  transform: "translate(0 0.18)"
}, React.createElement("g", {
  id: "Group_461",
  "data-name": "Group 461",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_468",
  "data-name": "Path 468",
  d: "M26.959,9.122h0l-1.765-.252a.454.454,0,0,1-.208-.812l1.427-1.07a.454.454,0,0,0,.091-.635L24.869,4.173a.454.454,0,0,0-.635-.091l-1.426,1.07a.454.454,0,0,1-.723-.427l.252-1.765a.454.454,0,0,0-.385-.514h0l-2.694-.385a.454.454,0,0,0-.514.385h0l-.252,1.765a.454.454,0,0,1-.812.208l-1.07-1.427a.454.454,0,0,0-.635-.091L14.61,3.926a8.78,8.78,0,0,0-1.856,0,8.622,8.622,0,0,0-7.6,7.731c-.012.128-.017.256-.023.383H4.992a.454.454,0,0,0-.444.363l-.314,1.491-1.256-.866a.454.454,0,0,0-.579.053L1.039,14.442a.454.454,0,0,0-.053.578l.862,1.254-1.492.314A.454.454,0,0,0,0,17.032v1.815a.454.454,0,0,0,.36.444l1.492.314L.99,20.859a.454.454,0,0,0,.053.578L2.4,22.8a.454.454,0,0,0,.579.053l1.254-.864.314,1.492a.454.454,0,0,0,.444.363H6.809a.454.454,0,0,0,.444-.36l.314-1.492,1.254.862A.454.454,0,0,0,9.4,22.8l.7-.707v1.293a1.809,1.809,0,0,0,.908,1.563V27.47a1.815,1.815,0,0,0,1.815,1.815h1.815a1.815,1.815,0,0,0,1.815-1.815V24.948a1.809,1.809,0,0,0,.908-1.563v-1.8a2.224,2.224,0,0,1,1.05-1.852,8.709,8.709,0,0,0,1.068-.817l-.605-.676a7.725,7.725,0,0,1-.956.731,3.126,3.126,0,0,0-1.464,2.614v1.8a.908.908,0,0,1-.908.908h-3.63a.908.908,0,0,1-.908-.908V21.552A3.053,3.053,0,0,0,9.572,18.99a7.691,7.691,0,0,1,4.065-14.2.493.493,0,0,0-.018.049.454.454,0,0,0,.087.336L14.775,6.6a.444.444,0,0,1,.027.5.451.451,0,0,1-.454.218l-1.765-.252a.454.454,0,0,0-.514.385h0l-.385,2.7a.454.454,0,0,0,.385.514h0l1.765.252a.454.454,0,0,1,.208.812L12.617,12.8a.454.454,0,0,0-.091.635l1.634,2.178a.454.454,0,0,0,.635.091l1.427-1.07a.454.454,0,0,1,.721.427l-.252,1.765a.454.454,0,0,0,.385.514h0l2.7.385a.5.5,0,0,0,.064,0,.454.454,0,0,0,.45-.389l.252-1.765a.454.454,0,0,1,.812-.208l1.07,1.426a.454.454,0,0,0,.635.091l2.178-1.634a.454.454,0,0,0,.091-.635l-1.07-1.426a.446.446,0,0,1-.027-.5.441.441,0,0,1,.454-.218l1.765.252a.454.454,0,0,0,.514-.385h0l.385-2.7A.454.454,0,0,0,26.959,9.122ZM11.919,25.2h3.63v.908h-3.63Zm0,1.815h3.63v.454a.908.908,0,0,1-.908.908H12.826a.908.908,0,0,1-.908-.908ZM8.306,19.19a8.577,8.577,0,0,0,.776.565A2.215,2.215,0,0,1,10,20.916l-.973.972-.943-.65a.908.908,0,0,0-1.4.56l-.238,1.133H5.36L5.122,21.8a.908.908,0,0,0-1.4-.56l-.943.648-.827-.825.649-.942a.908.908,0,0,0-.56-1.4L.908,18.479V17.4l1.131-.238a.908.908,0,0,0,.56-1.4l-.65-.945.827-.825.943.65a.908.908,0,0,0,1.4-.561L5.2,13.7a8.642,8.642,0,0,0,.36,1.539A2.723,2.723,0,1,0,8.306,19.19Zm-.7-.639a1.812,1.812,0,1,1-1.7-2.426h.017A8.6,8.6,0,0,0,7.6,18.551Zm18.521-6.8-1.316-.188a1.361,1.361,0,0,0-1.282,2.165l.8,1.063L22.87,15.881l-.8-1.063a1.361,1.361,0,0,0-2.437.624l-.184,1.318-1.8-.257.188-1.316a1.361,1.361,0,0,0-2.165-1.282l-1.063.8L13.526,13.25l1.063-.8a1.361,1.361,0,0,0-.624-2.437l-1.316-.188.257-1.8,1.316.188A1.361,1.361,0,0,0,15.5,6.054L14.7,4.99,16.156,3.9l.8,1.063A1.361,1.361,0,0,0,19.39,4.34l.188-1.316,1.8.256L21.187,4.6a1.361,1.361,0,0,0,2.165,1.282l1.063-.8L25.5,6.533l-1.063.8a1.361,1.361,0,0,0,.624,2.437l1.316.188Z",
  transform: "translate(0 -2.057)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_464",
  "data-name": "Group 464",
  transform: "translate(15.883 4.384)"
}, React.createElement("g", {
  id: "Group_463",
  "data-name": "Group 463"
}, React.createElement("path", {
  id: "Path_469",
  "data-name": "Path 469",
  d: "M283.63,76.171a3.63,3.63,0,1,0,3.63,3.63A3.63,3.63,0,0,0,283.63,76.171Zm0,6.353a2.723,2.723,0,1,1,2.723-2.723A2.723,2.723,0,0,1,283.63,82.524Z",
  transform: "translate(-280 -76.171)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_466",
  "data-name": "Group 466",
  transform: "translate(13.28 20.147)"
}, React.createElement("g", {
  id: "Group_465",
  "data-name": "Group 465"
}, React.createElement("rect", {
  id: "Rectangle_388",
  "data-name": "Rectangle 388",
  width: 0.908,
  height: 1.361,
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_468",
  "data-name": "Group 468",
  transform: "translate(7.377 5.241)"
}, React.createElement("g", {
  id: "Group_467",
  "data-name": "Group 467"
}, React.createElement("path", {
  id: "Path_470",
  "data-name": "Path 470",
  d: "M134.416,101.74a5.446,5.446,0,0,1-.919-9.681l-.485-.768a6.353,6.353,0,0,0,1.075,11.293,2.9,2.9,0,0,1,1.861,2.7h.908A3.8,3.8,0,0,0,134.416,101.74Z",
  transform: "translate(-130.044 -91.291)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_470",
  "data-name": "Group 470",
  transform: "translate(22.356 16.97)"
}, React.createElement("g", {
  id: "Group_469",
  "data-name": "Group 469"
}, React.createElement("rect", {
  id: "Rectangle_389",
  "data-name": "Rectangle 389",
  width: 3.177,
  height: 0.908,
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_472",
  "data-name": "Group 472",
  transform: "translate(21.612 19.344)"
}, React.createElement("g", {
  id: "Group_471",
  "data-name": "Group 471",
  transform: "translate(0 0)"
}, React.createElement("rect", {
  id: "Rectangle_390",
  "data-name": "Rectangle 390",
  width: 0.908,
  height: 3.544,
  transform: "matrix(0.64, -0.768, 0.768, 0.64, 0, 0.697)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_474",
  "data-name": "Group 474",
  transform: "translate(19.633 20.601)"
}, React.createElement("g", {
  id: "Group_473",
  "data-name": "Group 473"
}, React.createElement("rect", {
  id: "Rectangle_391",
  "data-name": "Rectangle 391",
  width: 0.908,
  height: 3.177,
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_476",
  "data-name": "Group 476",
  transform: "translate(0.463 7)"
}, React.createElement("g", {
  id: "Group_475",
  "data-name": "Group 475",
  transform: "translate(0 0)"
}, React.createElement("rect", {
  id: "Rectangle_392",
  "data-name": "Rectangle 392",
  width: 3.742,
  height: 0.907,
  transform: "translate(0 0.907) rotate(-14.035)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_478",
  "data-name": "Group 478",
  transform: "translate(1.217 2.534)"
}, React.createElement("g", {
  id: "Group_477",
  "data-name": "Group 477",
  transform: "translate(0 0)"
}, React.createElement("rect", {
  id: "Rectangle_393",
  "data-name": "Rectangle 393",
  width: 0.907,
  height: 3.904,
  transform: "matrix(0.581, -0.814, 0.814, 0.581, 0, 0.738)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_480",
  "data-name": "Group 480",
  transform: "translate(5.105 0.067)"
}, React.createElement("g", {
  id: "Group_479",
  "data-name": "Group 479",
  transform: "translate(0 0)"
}, React.createElement("rect", {
  id: "Rectangle_394",
  "data-name": "Rectangle 394",
  width: 0.908,
  height: 3.747,
  transform: "matrix(0.969, -0.248, 0.248, 0.969, 0, 0.225)",
  fill: "#fff"
})))));

var SvgTechnologyStackIcon = function SvgTechnologyStackIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27.349,
    height: 27.341,
    viewBox: "0 0 27.349 27.341",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTechnologyStackIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Technology stack icon.89a0f58b.svg";
export { ForwardRef as ReactComponent };